import { render, staticRenderFns } from "./DispatcherStatistics.vue?vue&type=template&id=3557420d&"
import script from "./DispatcherStatistics.vue?vue&type=script&lang=js&"
export * from "./DispatcherStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports